import type { EFormQuestion, EFormSubmitAnswer } from './eform.types'

/** Review with an "approved for public posting" box. */
export const APPROVAL_TYPE = 6

/** The suffix pages before the split appended to an approved review. */
const LEGACY_APPROVED_SUFFIX = '|approved'

/**
 * A review answer's text and approval. The page holds it as [text, '1' | '0'];
 * a plain string (a page loaded before the split, or a stored value) may end
 * in "|approved".
 */
export function readApproval(value: string | string[] | undefined | null): { text: string; approved: boolean } {
  if (Array.isArray(value)) {
    return { text: value[0] ?? '', approved: value[1] === '1' }
  }
  const str = value ?? ''
  if (str.endsWith(LEGACY_APPROVED_SUFFIX)) {
    return { text: str.slice(0, -LEGACY_APPROVED_SUFFIX.length), approved: true }
  }
  return { text: str, approved: false }
}

/**
 * The submit payload's answers. A review sends its text as `value` and its
 * box as `approved`, which the server stores where FTP does (responseContent
 * and responseNumber, R16). Every other answer is sent as the page holds it.
 */
export function toSubmitAnswers(
  answers: Record<number, string | string[]>,
  questions: EFormQuestion[]
): EFormSubmitAnswer[] {
  const typeByOrderId = new Map(questions.map((q) => [q.orderId, q.questionType]))
  return Object.entries(answers).map(([key, value]) => {
    const questionId = parseInt(key, 10)
    if (typeByOrderId.get(questionId) === APPROVAL_TYPE) {
      const { text, approved } = readApproval(value)
      return { questionId, value: text, approved }
    }
    return { questionId, value }
  })
}
